module.exports = __webpack_public_path__ + "static/tikoy-0b4a897a532f9340aef185a05d1986e3.jpg";